/**
 * Calculates the difference in milliseconds between two date strings.
 *
 * @param {string} dateStr1 - The first date string (ISO format or any valid date string).
 * @param {string} dateStr2 - The second date string (ISO format or any valid date string).
 * @returns {number} The time difference in milliseconds between dateStr1 and dateStr2.
 */
export function getTimeDifferenceInMilliseconds(dateStr1: string, dateStr2: string): number {
	const date1 = new Date(dateStr1);
	const date2 = new Date(dateStr2);
	return date1.getTime() - date2.getTime();
}
